import { useApi } from '../../hooks/useApi.js';
import { decodeMachineValue, encodeMachineValue } from './maintenance-shared.js';

/**
 * Combined machine selector — printers + equipment in one dropdown.
 * Value is a string like 'p:3' or 'e:7'; emits { printerId, equipmentId }
 * via onChange.
 */
export const MachinePicker = ({ value, onChange, disabled }) => {
  const { data: machines } = useApi('/equipment/machines');
  const printers = machines?.filter((m) => m.source === 'printer') ?? [];
  const equipment = machines?.filter((m) => m.source === 'equipment') ?? [];

  const handle = (e) => {
    const v = e.currentTarget.value;
    onChange(decodeMachineValue(v));
  };

  return (
    <select
      value={encodeMachineValue(value ?? {})}
      onChange={handle}
      disabled={disabled}
      class="block w-full rounded-md border border-border-strong bg-bg-card px-3 py-2 text-sm font-medium text-text-primary focus:border-brand focus:outline-none focus:ring-1 focus:ring-brand"
    >
      <option value="">Select a machine…</option>
      {printers.length > 0 && (
        <optgroup label="Printers">
          {printers.map((p) => <option key={`p${p.id}`} value={`p:${p.id}`}>{p.name}</option>)}
        </optgroup>
      )}
      {equipment.length > 0 && (
        <optgroup label="Equipment">
          {equipment.map((e) => <option key={`e${e.id}`} value={`e:${e.id}`}>{e.name} {e.kind ? `(${e.kind})` : ''}</option>)}
        </optgroup>
      )}
    </select>
  );
};
